// Scroll animations

/* eslint-disable wrap-iife */

/* global jQuery */

import simpleParallax from 'simple-parallax-js';

( function( $ ) {

	var image = document.getElementsByClassName('js-parallax--scroll');
    new simpleParallax(image, {
	scale: 1.1
});
    

} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/parallax.js